export default __webpack_public_path__ + "static/artifakt-legend-regular-4a654629113cff774a5e46bb601da832.eot";